/**
 * 从传入值中提取数字：
 * - 如果传入的是数字，直接返回；
 * - 如果传入的是字符串，提取连续的数字并转换为数字类型；
 * - 其他类型返回 undefined
 * @param value 待处理数据
 * @returns 数字值或 undefined
 * @example
 * console.log(extractNumber('22Mi')) // 输出 22
 * console.log(extractNumber(123)) // 输出 123
 * console.log(extractNumber('Mi22')) // 输出 undefined
 * console.log(extractNumber({})) // 输出 undefined
 */
export function extractNumber(value: unknown): number | undefined {
  if (typeof value === 'number') return value;
  if (typeof value !== 'string') return undefined;
  const match = value.match(/^\d+(\.\d+)?/);
  return match ? parseFloat(match[0]) : undefined;
}
